export default "__VITE_ASSET__BGvl0wek__"